import { defineComponent, ref, createElementBlock, openBlock, normalizeClass, createElementVNode, createCommentVNode, createTextVNode, toDisplayString, createVNode, mergeProps, withCtx, Fragment, renderList, createBlock } from 'vue';
import { useWindowSize } from './basler-components.es354.js';
import _sfc_main$2 from './basler-components.es122.js';
import _sfc_main$1 from './basler-components.es121.js';

const _hoisted_1 = ["innerHTML"];
const _hoisted_2 = ["onClick"];
const _hoisted_3 = { class: "visually-hidden" };
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "MainNavigationList",
  props: {
    level: {},
    index: {},
    parent: {},
    activeLevel: {},
    backButtonLabel: {},
    nextButtonLabel: {},
    setActiveClasses: { type: Boolean }
  },
  emits: ["back", "next", "navigate"],
  setup(__props, { emit: __emit }) {
    const props = __props;
    const emit = __emit;
    const { width } = useWindowSize();
    const activeIndex = ref(0);
    const onClick = (event, index, navigate) => {
      if (width.value >= 1024 && props.setActiveClasses) {
        event.preventDefault();
        activeIndex.value = index;
      } else {
        emit("navigate");
        navigate(event);
      }
    };
    const truncateText = (text) => {
      const num = 60;
      if (text.length > num) {
        return text.slice(0, num) + "…";
      } else {
        return text;
      }
    };
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("ul", {
        class: normalizeClass(["nav-main__list", `nav-main__list--level-${_ctx.level}`, { "is-active": _ctx.activeLevel[_ctx.level - 2] === _ctx.index }])
      }, [
        createElementVNode("li", {
          class: normalizeClass(["nav-main__item", `nav-main__item--level-${_ctx.level}`, "nav-main__item--previous-button"])
        }, [
          createElementVNode("button", {
            type: "button",
            class: "nav-main__previous-level",
            onClick: _cache[0] || (_cache[0] = ($event) => _ctx.$emit("back"))
          }, [
            _cache[6] || (_cache[6] = createElementVNode("span", { class: "nav-main__previous-level-arrow" }, null, -1)),
            createTextVNode(" " + toDisplayString(_ctx.backButtonLabel), 1)
          ])
        ], 2),
        createElementVNode("li", {
          class: normalizeClass(["nav-main__item", `nav-main__item--level-${_ctx.level}`, "nav-main__item--parent"])
        }, [
          createVNode(_sfc_main$1, mergeProps(_ctx.parent.link, {
            class: "nav-main__item-link",
            onClick: _cache[1] || (_cache[1] = ($event) => emit("navigate"))
          }), {
            default: withCtx(() => [
              createTextVNode(toDisplayString(_ctx.parent.altText || _ctx.parent.text), 1)
            ]),
            _: 1
          }, 16)
        ], 2),
        (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.parent.items, (item, index) => {
          return openBlock(), createElementBlock("li", {
            class: normalizeClass([
              "nav-main__item",
              `nav-main__item--level-${_ctx.level}`,
              { "nav-main__item--two-cols": item.isTwoColumns },
              { "nav-main__item--hide-mobile": item.hideOnMobile },
              { "nav-main__item--hide-desktop": item.hideOnDesktop },
              { "is-active": activeIndex.value === index }
            ]),
            key: `${item.text}-${index}`
          }, [
            createVNode(_sfc_main$2, mergeProps({ ref_for: true }, item.link, {
              class: "nav-main__item-link",
              onClick: (event, navigate) => onClick(event, index, navigate)
            }), {
              default: withCtx(() => [
                createElementVNode("span", {
                  innerHTML: truncateText(item.text)
                }, null, 8, _hoisted_1)
              ]),
              _: 2
            }, 1040, ["onClick"]),
            item.items ? (openBlock(), createElementBlock("button", {
              key: 0,
              type: "button",
              class: "nav-main__next-level",
              onClick: ($event) => _ctx.$emit("next", index)
            }, [
              _cache[7] || (_cache[7] = createElementVNode("span", { class: "nav-main__next-level-arrow" }, null, -1)),
              createElementVNode("span", _hoisted_3, toDisplayString(_ctx.nextButtonLabel), 1)
            ], 8, _hoisted_2)) : createCommentVNode("", true),
            item.items ? (openBlock(), createBlock(_sfc_main, {
              key: 1,
              level: _ctx.level + 1,
              index,
              parent: item,
              "active-level": _ctx.activeLevel,
              "back-button-label": _ctx.backButtonLabel,
              "next-button-label": _ctx.nextButtonLabel,
              "set-active-classes": false,
              onBack: _cache[2] || (_cache[2] = ($event) => _ctx.$emit("back")),
              onNext: _cache[3] || (_cache[3] = (subIndex) => _ctx.$emit("next", subIndex)),
              onNavigate: _cache[4] || (_cache[4] = ($event) => _ctx.$emit("navigate"))
            }, null, 8, ["level", "index", "parent", "active-level", "back-button-label", "next-button-label"])) : createCommentVNode("", true)
          ], 2);
        }), 128)),
        _ctx.parent.moreLink ? (openBlock(), createElementBlock("li", {
          key: 0,
          class: normalizeClass(["nav-main__item", `nav-main__item--level-${_ctx.level}`, "nav-main__item--more"])
        }, [
          createVNode(_sfc_main$1, mergeProps(_ctx.parent.moreLink.link, {
            class: "nav-main__item-link nav-main__item-link--more",
            onClick: _cache[5] || (_cache[5] = ($event) => emit("navigate"))
          }), {
            default: withCtx(() => [
              createTextVNode(toDisplayString(_ctx.parent.moreLink.text), 1)
            ]),
            _: 1
          }, 16)
        ], 2)) : createCommentVNode("", true)
      ], 2);
    };
  }
});

export { _sfc_main as default };
